import { render, staticRenderFns } from "./whatsappMe.vue?vue&type=template&id=46487603&scoped=true"
import script from "./whatsappMe.vue?vue&type=script&lang=js"
export * from "./whatsappMe.vue?vue&type=script&lang=js"
import style0 from "./whatsappMe.vue?vue&type=style&index=0&id=46487603&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46487603",
  null
  
)

export default component.exports